module.exports = __webpack_public_path__ + "img/dog_history.98083a3c.png";